import run from '../run';
import $ from 'jquery';

$(()=>{
  // create a new close helper so jquery/bootstrap versions don't conflict
  $(document).on("click", '.modal-auto-hide', function(e){
    e.preventDefault();
    const el = $(this);
    el.closest('.modal').modal('hide');
  });

});




// WEBPACK FOOTER //
// ./src/utilities/modalHelpers/index.js